
import React, { createContext, useContext } from 'react';
import { SidebarProvider as ShadcnSidebarProvider, useSidebar as useShadcnSidebar } from '@/components/ui/sidebar';

// Simple wrapper that exposes Shadcn's sidebar functionality
export const useSidebar = () => {
  const sidebar = useShadcnSidebar();
  if (!sidebar) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return sidebar;
};

// Main provider component
interface SidebarProviderProps {
  children: React.ReactNode;
  defaultOpen?: boolean;
}

export const SidebarProvider: React.FC<SidebarProviderProps> = ({ 
  children, 
  defaultOpen = true 
}) => {
  return (
    <ShadcnSidebarProvider defaultOpen={defaultOpen}>
      {children}
    </ShadcnSidebarProvider>
  );
};
